<div
	class="questionContainer"
	[formGroup]="questionBuilderFormGroup"
>

	<div class="questionCard">

		<div
			class="questionFirstLine"
			id="{{ 'qBuilder_' + question.id }}"
		>

			<mat-form-field
				appearance="outline"
				subscriptSizing="dynamic"
				class="questionLabel"
			>
				<mat-label>Frage</mat-label>
				<input
					matInput
					type="text"
					formControlName="label"
				>
			</mat-form-field>

			@if( !bLockedForm ) {

				<div class="deleteButton">
		
					@if( bSaving ) {
						<mat-spinner diameter="23" />
					}
					@else {
						<span
							class="material-icons iconBtn"
							(click)="clickRemoveQuestion()"
							title="Frage entfernen"
						>
							delete
						</span>
					}
		
				</div>

			}
			
		</div>

		<div class="questionFields">

			<mat-form-field
				appearance="outline"
				subscriptSizing="dynamic"
			>
				<mat-label>Typ</mat-label>
				<mat-select formControlName="type">

					<mat-option value="check">
						Kontrollkästchen
					</mat-option>
					<mat-option value="number">
						Nummer
					</mat-option>
					<mat-option value="text">
						Text
					</mat-option>
					<mat-option value="textarea">
						Textbereich
					</mat-option>
					<mat-option value="MehrwachUnterfragen">
						MehrwachUnterfragen
					</mat-option>

				</mat-select>
			</mat-form-field>

			<mat-form-field
				appearance="outline"
				subscriptSizing="dynamic"
			>
				<mat-label>Bedingung</mat-label>
				<input
					matInput
					type="text"
					formControlName="childrenCondition"
				>
			</mat-form-field>

			<mat-form-field
				appearance="outline"
				subscriptSizing="dynamic"
			>
				<mat-label>Auschluss</mat-label>
				<mat-select formControlName="exclusion">

					<mat-option value="">
						Keiner
					</mat-option>

					@for( sibling of siblings; track sibling.id ) {
						@if( sibling.id != question.id ) {
							<mat-option [value]="sibling.id">
								{{ (sibling.label && sibling.label.trim().length) ? sibling.label : '(' + sibling.id + ')' }}
							</mat-option>
						}
					}

				</mat-select>
			</mat-form-field>

			<mat-checkbox formControlName="required">
				Benötigt
			</mat-checkbox>

			<mat-checkbox formControlName="deregistration">
				Abmeldefrage
			</mat-checkbox>

		</div>

	</div>

	@if( bQuestionUpdateError ) {
		<div class="errorWarning">
			Beim Speichern der Frage ist ein Fehler aufgetreten
		</div>
	}

	@if( bKidCreationError ) {
		<div class="errorWarning">
			Beim Hinzufügen der Frage ist ein Fehler aufgetreten
		</div>
	}

	@if( bDeleteError ) {
		<div class="errorWarning" style="padding: 0;">
			Beim Entfernen der Frage ist ein Fehler aufgetreten
		</div>
	}


	<div class="subQuestions">

		<div class="subQuestionsTopLine">

			@if( question.children.length ) {

				<button
					mat-raised-button
					(click)="bShowKids = !bShowKids"
					title="Anzeige der Unterfragen umschalten"
				>
					<div class="iconAndTxt">
						<span class="material-icons">{{ bShowKids ? "visibility" : "visibility_off" }}</span>
						<span>Unterfragen</span>
					</div>
				</button>

			}

			@if( !bLockedForm && bShowKids ) {

				<button
					[@flyInOut]
					mat-raised-button
					(click)="clickAddQuestion()"
				>
					<div class="iconAndTxt">
						<span class="material-icons">add</span>
						<span>Unterfrage hinzufügen</span>
					</div>
				</button>

			}

		</div>

		@if( bShowKids && question.children.length ) {

			<question-builder-branch
				[branch]="question.children"
				[@foldInOut]
				style="display: block;"
			/>
			<!-- display: block for the animation -->

		}

	</div>

</div>


